export default {
  name: 'header-simple',
  components: {
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {

  },
}


